import { render, staticRenderFns } from "./GMResolutionPreviewPage.vue?vue&type=template&id=53daf5cb&scoped=true&"
import script from "./GMResolutionPreviewPage.vue?vue&type=script&lang=ts&"
export * from "./GMResolutionPreviewPage.vue?vue&type=script&lang=ts&"
import style0 from "./GMResolutionPreviewPage.vue?vue&type=style&index=0&id=53daf5cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53daf5cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
